module.exports = __webpack_public_path__ + "./img/header-menu.svg";